module.exports = __webpack_public_path__ + "static/img/ponteDiavolo.1688c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/territorio/ponteDiavolo.jpg
// module id = QE4H
// module chunks = 1